import { render } from "./AttachmentsList.vue?vue&type=template&id=ec5c04c4&scoped=true"
import script from "./AttachmentsList.vue?vue&type=script&lang=js"
export * from "./AttachmentsList.vue?vue&type=script&lang=js"

import "./AttachmentsList.vue?vue&type=style&index=0&id=ec5c04c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec5c04c4"]])

export default __exports__